import { AnalyticsBrowser } from '@segment/analytics-next';

// Load the Analytics library
export const analytics = AnalyticsBrowser.load({
  writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY as string
});

export const segmentIntegrations = {
  integrations: {
    All: false,
    Iterable: true,
    Heap: true
  }
};

export const iterableIntegrations = {
  integrations: {
    All: false,
    Iterable: true
  }
};

export const heapIntegrations = {
  integrations: {
    All: false,
    Heap: true
  }
};
